<template>
  <div id="home">

    <!-- Mainview Area Start -->
    <div id="mainview">
      
      <!-- Logo-box -->
      <div class="logo-box">
        <span>M</span>
        <span>E</span>
        <span>G</span>
        <span>A</span>
        <span>B</span>
        <span>O</span>
        <span>X</span>
        <span>H</span>
        <span>O</span>
        <span>M</span>
        <span>E</span>
      </div>

      <!-- main image -->
      <img src="../assets/images/poster.jpg" alt="메인 이미지">

      <!-- button -->
      <p>
        <router-link to="/sub" class="btn btn2">자세히 보기</router-link>
      </p>
    
    </div>
    
    <!-- Contents Area Start -->
    <div id="contents">
      <!-- Movie Group1 -->
      <div class="movie-group1">

        <h3>신규 추천 영화</h3>

        <div id="slider1">

          <!-- Slider 구성시작 -->
          <div class="swiper-wrapper">
        <!-- Slides -->
        <div class="swiper-slide">
          <img src="../assets/images/poster1.jpg" alt="photo1">
        </div>
        <div class="swiper-slide">
          <img src="../assets/images/poster2.jpg" alt="photo2">
        </div>
        <div class="swiper-slide">
          <img src="../assets/images/poster3.jpg" alt="photo3">
        </div>
        <div class="swiper-slide">
          <img src="../assets/images/poster1.jpg" alt="photo4">
        </div>
        <div class="swiper-slide">
          <img src="../assets/images/poster2.jpg" alt="photo5">
        </div>
        <div class="swiper-slide">
          <img src="../assets/images/poster3.jpg" alt="photo6">
        </div>
          </div>

          <!-- prev & next 좌우버튼 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>

        </div>
      
      </div>
      
      <!-- Movie Group2 -->
      <div class="movie-group2">

        <h3>상영 예정작</h3>
        <div id="slider2">
           <!-- Slider 구성시작 -->
           <div class="swiper-wrapper">
        <!-- Slides -->
        <div class="swiper-slide">
          <img src="../assets/images/poster1.jpg" alt="photo1">
        </div>
        <div class="swiper-slide">
          <img src="../assets/images/poster2.jpg" alt="photo2">
        </div>
        <div class="swiper-slide">
          <img src="../assets/images/poster3.jpg" alt="photo3">
        </div>
        <div class="swiper-slide">
          <img src="../assets/images/poster1.jpg" alt="photo4">
        </div>
        <div class="swiper-slide">
          <img src="../assets/images/poster2.jpg" alt="photo5">
        </div>
        <div class="swiper-slide">
          <img src="../assets/images/poster3.jpg" alt="photo6">
        </div>
          </div>

          <!-- prev & next 좌우버튼 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      
      </div>
      
      <!-- Movie Group3 -->
      <div class="movie-group3">

        <h3>박스 오피스</h3>
        <div id="slider3">
           <!-- Slider 구성시작 -->
           <div class="swiper-wrapper">
        <!-- Slides -->
        <div class="swiper-slide">
          <img src="../assets/images/poster1.jpg" alt="photo1">
        </div>
        <div class="swiper-slide">
          <img src="../assets/images/poster2.jpg" alt="photo2">
        </div>
        <div class="swiper-slide">
          <img src="../assets/images/poster3.jpg" alt="photo3">
        </div>
        <div class="swiper-slide">
          <img src="../assets/images/poster1.jpg" alt="photo4">
        </div>
        <div class="swiper-slide">
          <img src="../assets/images/poster2.jpg" alt="photo5">
        </div>
        <div class="swiper-slide">
          <img src="../assets/images/poster3.jpg" alt="photo6">
        </div>
          </div>

          <!-- prev & next 좌우버튼 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      
      </div>


    </div>

     <!-- Footer Area Start -->
    <AppFooter></AppFooter>


  </div>
</template>

<script>
import AppFooter from './component/Footer.vue';

  export default {
    name: "Home",
    components: {
      // AppFooter: AppFooter 축약어로 가능합니다
      AppFooter
    },
    mounted(){
      this.slider1();
      this.slider2();
      this.slider3();
    },
    methods: {
      slider1(){
        const swiper = new Swiper('#slider1, #slider2, #slider3', {
      direction: 'horizontal',
      loop: true,
      slidesPerView: 3,
      spaceBetween: 20,
      autoplay: {
        delay: 3000
      },
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      // Effect : 'slide', 'fade', 'cube', 'coverflow', 'flip', 'creative', 'cards'
      effect: 'slide'
  });

    }
  }
}

</script>

<style lang="scss" scoped>
@import "../sass/partials/mixin", "../sass/partials/variable";

#home{
  padding: 0px;

  // Mainview Area Start
  #mainview{
    position: relative;
    margin-bottom: 80px;
    // logo-box
    .logo-box{
      width: 180px;
      height: 20px;
      position: absolute; left: 30px; top: 30px;

      span{
        display: block;
        width: 15px;
        height: 100%;
        float:left;
        background-color: #fff;
        color : #000;
        text-align: center;
        margin-right: 1px;
        @include font-set(900, 1.4rem, 20px, $ff4);
        
        &:nth-child(7){margin-right: 3px;}
      }
    }
    // img
    img{ width: 100%; margin-bottom: 25px; }

    p{
      text-align: center;
      .btn2{ width: 240px; height: 40px; line-height: 40px; }
    }


  }

  // Contents Area Start
  #contents{
    padding: 0 20px 84px;    
    >div{
      width: 100%;
      height: 140px;
      margin-bottom: 30px;
      position: relative;
      overflow: hidden;
      h3{
        margin-bottom: 20px;
        @include font-set(700, 1.8rem, 21px, $ff1);
      }
      img{
        display: inline-block;
      }
      // prev & Next
      .swiper-button-next, .swiper-button-prev{
        top: 90px;
        color : $color3;
      }
    }
  }

}










</style>


// WEBPACK FOOTER //
// src/components/Home.vue